import React, { useState, useEffect, useContext, useRef } from 'react'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { PageBase } from 'alpha-page'
import { Route, Link as RouterLink, withRouter } from 'react-router-dom'

import { getContentRecord, fetchContentRecord } from '../../../store/alpha'

import { withStyles } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'


const styles = theme => ({
  root: {
//    maxWidth: 480,
//    display: 'flex',
    width: '100%',
    minHeight: '100vh'
  },
  content: {
  },
  divider: {
    width: '100%',
    height: theme.spacing.unit,
//    backgroundColor: theme.palette.common.white,
    backgroundColor: '#eee'
  }
})

const PageController = ( props ) => {

  const { classes, theme, history, isFetching, lastFetched, data, newSectionMaps, newContentBlockMaps, fetchPageRecord, pageKey } = props

  const [initialized, setInitialized] = useState(false);

  let smUp = useMediaQuery(theme.breakpoints.up('sm'))
  
  const topElement = useRef()
  
  useEffect(() => {
    fetchPageRecord()

    // if (lastFetched)
    //   logEvent('view', { type: 'content', uid: data.uid })
      
  }, [pageKey, lastFetched])
  
  return (
    <PageBase theme={theme} lastFetched={lastFetched} data={lastFetched ? data : {}} {...props}/>
  )

}

function pageKeyFromProps(props) {
  let key = null
  if (props.slug && props.slug !== undefined)
    key = props.slug
  else if (props.pageKey && props.pageKey !== undefined)
    key = props.pageKey
  else
    key = props.match.params.pageKey
    
  if (!key || key == undefined)
    key = 'home'

  return key
}

function popupLinkFromProps(props) {
  let link = null
/*
  if (props.match) {
    if (props.match.params.storyKey !== undefined)
      link = "story/" + props.match.params.storyKey
    else if (props.match.params.productKey !== undefined)
      link = "product/" + props.match.params.productKey
  }
*/
  return link
}

const mapStateToProps = (state, ownProps) => {
  let key = pageKeyFromProps(ownProps)
  
  return {
    ...getContentRecord(state, "page", key),
    pageKey: key,
    popupLink: popupLinkFromProps(ownProps),
  }
} 

const mapDispatchToProps = (dispatch, ownProps) => {
  let key = pageKeyFromProps(ownProps)

  return {
    fetchPageRecord: () => {
      dispatch(fetchContentRecord('page', key))
    },
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(PageController)
  )
)